import * as echarts from 'echarts';
import i18next from '../translations/i18n';

export const formatChartDate = value => {
  const date = new Date(value);
  const locale = i18next.language?.startsWith('en') ? 'en-US' : i18next.language || 'en-US';
  return date.toLocaleDateString(locale, {
    weekday: 'long',
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
};

export const chartTooltipStyle = {
  renderMode: 'html',
  className: 'wt-chart-tooltip',
  backgroundColor: '#f7f8f9',
  borderColor: '#0047bb',
  borderWidth: 1,
  borderRadius: 0,
  shadowBlur: 0,
  padding: [8, 16],
  confine: true,
  position(point, params, element, rect, size) {
    const gap = 14;
    const tooltipWidth = size.contentSize[0];
    const tooltipHeight = size.contentSize[1];
    const fitsRight = point[0] + gap + tooltipWidth <= size.viewSize[0];
    const fitsLeft = point[0] - gap - tooltipWidth >= 0;

    element?.classList?.toggle('wt-chart-tooltip--left', !fitsRight && fitsLeft);
    element?.classList?.toggle('wt-chart-tooltip--no-arrow', !fitsRight && !fitsLeft);

    let x = Math.max(0, (size.viewSize[0] - tooltipWidth) / 2);
    if (fitsRight) {
      x = point[0] + gap;
    } else if (fitsLeft) {
      x = point[0] - gap - tooltipWidth;
    }
    const y = Math.max(0, Math.min(point[1] - tooltipHeight / 2, size.viewSize[1] - tooltipHeight));

    return [x, y];
  },
};

export const formatChartTooltip = (params, formatValue) => {
  const rows = [
    [i18next.t('DATE'), formatChartDate(params[0].axisValue)],
    ...params.map(param => [param.seriesName, formatValue(param.value)]),
  ];

  return rows
    .map(
      ([label, value]) => `
        <div class="wt-chart-tooltip__row">
          <span class="wt-chart-tooltip__label">${echarts.format.encodeHTML(label)}</span>
          <span class="wt-chart-tooltip__value">${echarts.format.encodeHTML(String(value))}</span>
        </div>`,
    )
    .join('');
};
